import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M7.234 17.202C4.348 17.202 2 14.869 2 12C2 9.13097 4.348 6.79797 7.234 6.79797C9.138 6.79797 10.898 7.83897 11.805 9.47597H19.538C20.895 9.47597 21.999 10.575 21.999 11.925V12.075C21.999 13.426 20.895 14.523 19.538 14.523H19.185L18.241 15.454C18.051 15.643 17.744 15.647 17.546 15.467L16.709 14.703L15.873 15.467C15.675 15.648 15.368 15.644 15.178 15.454L14.234 14.523H11.805C10.897 16.161 9.137 17.202 7.234 17.202V17.202ZM7.234 7.80897C4.905 7.80897 3.011 9.68897 3.011 12C3.011 14.311 4.906 16.192 7.234 16.192C8.859 16.192 10.353 15.254 11.04 13.802C11.123 13.625 11.301 13.513 11.497 13.513H14.441C14.574 13.513 14.701 13.565 14.795 13.658L15.545 14.397L16.368 13.645C16.561 13.469 16.856 13.469 17.05 13.645L17.874 14.397L18.624 13.658C18.719 13.565 18.846 13.513 18.978 13.513H19.538C20.338 13.513 20.989 12.867 20.989 12.075V11.925C20.989 11.132 20.338 10.487 19.538 10.487H11.497C11.302 10.487 11.124 10.374 11.04 10.198C10.353 8.74597 8.859 7.80897 7.234 7.80897V7.80897Z"
      fill="currentColor"
    />
    <path
      d="M5.3549 13.448C4.5529 13.448 3.8999 12.799 3.8999 12C3.8999 11.201 4.5519 10.551 5.3549 10.551C6.1579 10.551 6.8099 11.201 6.8099 12C6.8099 12.799 6.1569 13.448 5.3549 13.448V13.448ZM5.3549 11.562C5.1099 11.562 4.9109 11.758 4.9109 12C4.9109 12.242 5.1099 12.438 5.3549 12.438C5.5999 12.438 5.7989 12.242 5.7989 12C5.7989 11.758 5.5999 11.562 5.3549 11.562Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Key');

export default Icon;
